@if (display) {
  <p-dialog [styleClass]="authenticationService?.user?.fontSize === 'SMALL' ? 'custom-form-small' : (authenticationService?.user?.fontSize === 'MEDIUM' ? 'custom-form-medium' : '')" header="{{title}}" [(visible)]="display" showEffect="fade" [modal]="true" appendTo="body">
<div [ngClass]="{'custom-form-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-form-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
    <!-- #region FORM BODY -->
    <div class="container-md">
      <div class="ui-grid-row">
        <div class="ui-grid-col-12">
          @for (msg of messages; track msg) { <p-message [severity]="msg.severity" [text]="msg.detail"></p-message> }
        </div>
      </div>
      <!-- NAME -->
      <div class="row mt-3">
        <div class="col-12">
          <label for="brand-name" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
          {{'general.name' | translate}}
        </label>
          <input type="text" id="brand-name" class="form-control custom-input" [(ngModel)]="entity.name">
        </div>
      </div>
      <!-- ROW 4: LOGO IMAGE & ADD IMAGE BUTTON -->
      <div class="row mt-2 mb-4">
        <!-- PROFILE IMAGE -->
        <img #image src="{{brandEncodedImage}}" class="custom-user-profile-image mx-auto d-block p-0 mt-3">
        <!-- ADD IMAGE BUTTON -->
        <div id="outer-icon-holder" class="d-flex mx-auto align-items-center justify-content-center">
          <div id="inner-icon-holder" class="d-flex align-items-center justify-content-center"
            (click)='uploadImageInput.click()'>
            <img src="assets/icons/camera-plus.png" class="custom-user-profile-icon" />
            <input #uploadImageInput [hidden]='true' type='file' accept='.jpg, .png' (change)='imageChange($event)'>
          </div>
        </div>
      </div>
    </div>
    <!-- #endregion FORM BODY -->
  </div>
<!-- #region FOOTER -->
<ng-template pTemplate="footer">
      <div class="d-flex justify-content-center bd-highlight">
        <div class="p-2 bd-highlight">
          @if (isNew) {
            <div>
              <button class="btn custom-button" (click)="saveChanges()" i18n>
                {{'general.create' | translate}}
              </button>
            </div>
          }
          @if (!isNew) {
            <div>
              <button class="btn custom-button" (click)="saveChanges()" [disabled]="disableSave" i18n>
                {{'general.save' | translate}}
              </button>
            </div>
          }
        </div>
      </div>

      <div class="p-2 bd-highlight">
        @if (!isNew) {
          <div>
            <button class="btn custom-button" (click)="changeStatus(!entity.disabled)" [disabled]="disabeChangeStatus" i18n>
              {{'general.changeStatus' | translate}}
            </button>
          </div>
        }
      </div>
    </ng-template>
<!-- #endregion FOOTER -->
</p-dialog>
}